export const ITEMS_CHUNK_SIZE = 100;
export const START_PAGINATION = {
    top: ITEMS_CHUNK_SIZE,
    skip: 0
};
export const BffRequestTypes = {
    league: {
        method: "getLeaguesBySportId",
        entity: "leagues"
    },
    sports: {
        method: "getSports",
        entity: "sports"
    }
};
//# sourceMappingURL=constants.js.map